
import Cpu from "../../../assets/filled/Cpu.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CpuIcon({ className, dataTestid = "CpuIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Cpu data-testid={dataTestid} className={classes} {...rest} />
  );
}
